export default (covers,transparentLevels = []) =>  ({
    transition_duration: 0,
    floor_visibility_strategy_on_start: {
        type: /*covers ? 'hide_all' : */'show_all',
        params: {
            show_outdoor: true,
            show_covers: covers,
        }
    },
    floor_visibility_strategy_on_finish: {
        type:  /*covers ? 'hide_all' : */'show_all',
        params: {
            show_outdoor: true,
            show_covers: covers,
        }
    },
    /*  floor_transparency_strategy:{
        type: 'set_on_buildings',
        params:{
            selected_ids:transparentLevels,
        }
    },*/
    event_strategy: {
        click_on_buildings: !covers,
        click_on_stores: false,
        click_on_floors: false,
        click_on_covers: covers,
    }

})
